import React, { Component } from 'react';
import BACKEND_URL from '../../config';

class EmployeeCard extends Component {
    constructor(props, context) {
      super(props, context);
        this.state = {
          employee: {}
        };
    }
    componentDidMount() {
      fetch(`${BACKEND_URL}/employees/${this.props.match.params.id}`)
        .then(res => res.json())
        .then(employee => {
          return this.setState({ employee: employee[0] })});
          
    } 
  
    render() {
      return (
        <article className="mw6 center bg-white br3 pa3 pa4-ns mv3 ba b--black-10">
          <div className="tc">
            <img src={this.state.employee.url} className="br3 ba b--black-10 h3 w3" alt="Employee profile pic"/>
            <h1 className="f4">{this.state.employee.first_name} {this.state.employee.last_name}</h1>
            <hr className="mw5 bb bw1 b--black-10"/>
          </div>
          <div className="pa3 pa5-ns">
            <dl className="f6 lh-title mv2">
              <dt className="dib b">Email:</dt>
              <dd className="dib ml2 gray">{this.state.employee.email}</dd>
            </dl>
            <dl className="f6 lh-title mv2">
              <dt className="dib b">Phone:</dt>
              <dd className="dib ml2 gray">{this.state.employee.phone}</dd>
            </dl>
            <dl className="f6 lh-title mv2">
              <dt className="dib b">Position / Department:</dt>
              <dd className="dib ml2 gray">{this.state.employee.position} / {this.state.employee.department}</dd>
            </dl>
            <dl className="f6 lh-title mv2">
              <dt className="dib b">Hire date:</dt>
              <dd className="dib ml2 gray">{this.state.employee.hire_date}</dd>
            </dl>
          </div>
        </article>
        
      );
    }
  }

  export default EmployeeCard;


// WEBPACK FOOTER //
// ./src/components/employee/EmployeeCard.js